<template>
  <div class="kye-report-echarts-pie-legend" :class="legendClassName">
    <div class="kye-report-echarts-pie-legend_header" v-if="showTableMode">
      <div class="kye-report-echarts-pie-legend_header_th"
        @click="legendHeader(column, index)"
        v-for="(column, index) in columns"
        :title="column.useTitle === false ? '' : (useTitle ? column.name : '')"
        :style="getStyle(column)"
        :class="getClass(column)"
        :key="index">
        {{ column.name }}
        <Sort
          class="kye-report-echarts-pie-sort"
          v-if="column.sort"
          :type="column.sortType"
          @sort="sort($event, column)" />
      </div>
    </div>
    <div class="kye-report-echarts-pie-legend_container">
      <div class="kye-report-echarts-pie-legend_item"
        v-for="(item, index) in legendData"
        :class="{
          'legend_item-select': item.select
        }"
        :key="index">
        <div class="kye-report-echarts-pie-legend_item_c"
          @click="legendClick(item, index)"
          @mouseover="legendHover(item, index, ['highlight', 'showTip'])"
          @mouseout="legendHover(item, index, ['downplay', 'hideTip'])"
          :style="getStyle(columns[0])"
          :class="getClass(columns[0])">
          <!-- 颜色标签 -->
          <div class="kye-report-echarts-pie-legend_mark"
            @click.stop="legendClick(item, index, 'mark')"
            :style="`background:${item.select ? item.color : '#999999'}`">
          </div>
          <div class="kye-report-echarts-pie-legend_value"
            :class="{
              'legend_item-fontWeight_bold': hoverCurIndex === index
            }"
            :title="useTitle ? (showTableMode ? item[columns[0].key] : item[propsConfig.label]) : ''"
            :style="`color:${item.select ? '#333333' : '#999999'}`"
            v-html="formatLabel(item, columns)">
          </div>
        </div>
        <!-- 表格选项 -->
        <div class="kye-report-echarts-pie-legend_columns" v-if="showTableMode">
          <div class="kye-report-echarts-pie-legend_columns_item"
            v-html="formatValue(item, column)"
            @click="legendClick(item, index, 'column', column)"
            :title="column.useTitle === false ? '' : (useTitle ? item[column.key] : '')"
            v-for="(column, index) in legendColumns"
            :key="index"
            :style="getStyle(column)"
            :class="getClass(column)">
          </div>
        </div>
        <!-- 上下布局 -->
        <div class="kye-report-echarts-pie-legend_item_v"
          v-html="formatValue(item)"
          :style="`color:${item.select ? '#333333' : '#999999'}`"
          @click="legendClick(item, index, 'value')"
          v-if="item.showValue" >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sort from '../bar-x/txt003/sort.vue'

export default {
  props: {
    code: String,
    data: Array,
    echartsConfig: Object,
    columns: Array,
    showTableMode: Boolean,
    propsConfig: Object,
    hoverCurIndex: String | Number,
    colors: Array,
    useTitle: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Sort
  },
  data() {
    return {
      legendData: []
    }
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(this.getLegendData)
      },
      immediate: true
    },
    colors() {
      this.$nextTick(this.getLegendData)
    }
  },
  computed: {
    legendClassName() {
      return `kye-report-echarts-pie-legend_${this.code}`
    },
    legendColumns() {
      return this.columns.slice(1)
    }
  },
  methods: {
    sort(sortType, column) {
      this.$parent.$emit('sort', sortType, column)
    },
    getLegendData() {
      const { data, code, colors } = this
      if (!data.length || !colors.length) {
        return []
      }
      const colorLength = colors.length
      let currentIndex = 0
      this.legendData = data.map(i => {
        const { itemStyle = {}, legendOption = {} } = i
        if (colorLength === currentIndex) currentIndex = 0
        const _color = itemStyle.color || colors[currentIndex]
        currentIndex += 1
        const legendItemData = {
          color: _color,
          ...i,
          select: true,
          ...legendOption, // 替换默认
          showValue: ['002', '004'].some(i => code.includes(i)),
        }
        // 默认都是全部展开, 有关闭需要走初始化
        if (legendItemData.select === false) {
          this.legendToggleSelect(legendItemData.name)
        }
        return legendItemData
      })
    },
    legendHeader(column, index) {
      this.$parent.$emit('legendHeader', column, index, 'header')
    },
    legendClick(legendItem, index, type, column) {
      const echartsInstance = this.$parent.echartsInstance
      if (!echartsInstance) return
      if (type !== 'column') {
        this.legendToggleSelect(legendItem.name)
        legendItem.select = !legendItem.select
        if (!legendItem.select) {
          Promise.resolve(echartsInstance.dispatchAction({type: 'hideTip'}))
        }
      }
      this.$parent.$emit('legendClick', legendItem, index, type, column)
    },
    legendToggleSelect(name) {
      const echartsInstance = this.$parent.echartsInstance
      if (!echartsInstance || !name) return
      echartsInstance.dispatchAction({
        type: 'legendToggleSelect',
        name
      })
    },
    legendHover(legendItem, index, types) {
      const [ legend, tip ] = types
      const echartsInstance = this.$parent.echartsInstance
      if (!echartsInstance || !legendItem.select) return
      echartsInstance.dispatchAction({ type: legend, seriesIndex: 0, dataIndex: index })
      echartsInstance.dispatchAction({ type: tip, seriesIndex: 0, dataIndex: index })
    },
    formatValue(item = {}, column = {}) {
      const { legendFormatValue } = item
      let { value } = this.$props.propsConfig
      const KeyName = column.key
      // 表格
      if (this.showTableMode && KeyName) {
        value = KeyName
      }
      return typeof legendFormatValue === 'function' ? legendFormatValue(item, column) : item[value]
    },
    formatLabel(item = {}, column = {}) {
      const { legendFormatLabel } = item
      let { label } = this.$props.propsConfig
      const KeyName = column.key
      // 表格
      if (this.showTableMode && KeyName) {
        label = KeyName
      }
      return typeof legendFormatLabel === 'function' ? legendFormatLabel(item, column) : item[label]
    },
    getStyle(column = {}) {
      const styleCallback = column.style || (() => {})
      const styles = {
        ...styleCallback(column)
      }
      if (column.width) {
        styles.width = parseInt(column.width) + 'px'
      }
      return styles
    },
    getClass(column = {}) {
      const classCallback = column.class || (() => '')
      const _class = classCallback ? ((typeof classCallback === 'function' && classCallback(column)) || classCallback) : ''
      return _class
    }
  }
}
</script>

<style lang="less">
  .kye-report-echarts-pie-legend{
    &_Hxt001, &_Hxt002, &_Bt001, &_Bt002{
      width: 100%;
      padding: 0 50px;
      padding-bottom: 16px;
      .kye-report-echarts-pie-legend_container{
        display: flex;
        flex-wrap: wrap;
        gap: 6px 16px;
      }
    }
    &_Hxt003, &_Hxt004, &_Bt003, &_Bt004{
      margin-left: 60px;
      .kye-report-echarts-pie-legend_container{
        display: flex;
        flex-wrap: wrap;
        gap: 6px 16px;
      }
    }
    &_Hxt005, &_Bt005{
      padding: 16px 0;
      display: flex;
      flex-direction: column;
      height: 100%;
      .kye-report-echarts-pie-legend_container{
        height: 100%;
        overflow-y: auto;
        >div:first-child{
          margin-top: 0;
        }
        &::-webkit-scrollbar{
          width: 4px;
          height: 4px;
        }
        &::-webkit-scrollbar-thumb{
          border-radius: 2px;
          background-color: rgba(118, 83, 214, .4);
        }
      }
      .kye-report-echarts-pie-legend_item{
        margin-top: 6px;
        width: 100%;
        display: flex;
        font-size: 12px;
        &_c{
          width: 88px;
        }
      }

    }
    .legend_item-select:hover .kye-report-echarts-pie-legend_value{
      font-weight: bold;
    }
    .legend_item-fontWeight_bold {
      font-weight: bold;
    }
    &_header{
      margin-bottom: 12px;
      display: flex;
      padding-right: 63px;
      &_th{
        color: #999999;
        width: 45px;
        font-size: 12px;
        margin-left: 24px;
        display: flex;
        align-items: center;
      }
      >div:last-child{
        text-align: right;
      }
      >div:first-child{
        width: 88px;
        padding-left: 16px;
        margin-left: 0;
      }
    }
    &_columns{
      display: flex;
      &_item{
        width: 45px;
        margin-left: 24px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    &_item{
      width: 84px;
      &_c{
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      &_v{
        width: 100%;
        padding-left: 16px;
        font-size: 12px;
        font-weight: 600;
      }
    }
    &_mark{
      width: 8px;
      height: 8px;
      border-radius: 4px;
      margin-right: 8px;
    }
    &_value{
      font-size: 12px;
      font-weight: normal;
      color: #333333;
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .kye-report-echarts-pie-sort{
      top: -4px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/pie/legend.vue